import React, { useState } from "react";

const ItemComponent = React.memo(function ItemComponent({ item }) {
    console.log("Rendered Item:", item.id);
    return (
        <div style={{ border: "1px solid gray", margin: 4, padding: 8 }}>
            <div>ID: {item.id}</div>
            <div>Name: {item.name}</div>
            <div>Value: {item.value}</div>
        </div>
    );
})

export default function Testing() {
    const [items, setItems] = useState([
        { id: 1, name: "Item 1", value: 10 },
        { id: 2, name: "Item 2", value: 20 },
        { id: 3, name: "Item 3", value: 30 },
    ]);
    console.log(items);
    const updateValue = (idToUpdate) => {
        const updatedItems = [...items];
        const index = updatedItems.findIndex((i) => i.id === idToUpdate);
        if (index !== -1) {
            let updatedItem = updatedItems[index]; // modify field, same object reference
            updatedItem = { ...updatedItem, value: updatedItem.value + 1 };
            updatedItems[index] = updatedItem;
        }
        setItems(updatedItems);
    };
    // console.log('rendered');
    return (
        <div>
            <h2>Without React.memo</h2>
            <button onClick={() => updateValue(2)}>Update Item 2's Value</button>
            {items.map((item) => (
                <ItemComponent key={item.id} item={item} />
            ))}
        </div>
    );
}
